import { render, staticRenderFns } from "./VIPBag.vue?vue&type=template&id=1a9fb9b9&scoped=true&"
import script from "./VIPBag.vue?vue&type=script&lang=js&"
export * from "./VIPBag.vue?vue&type=script&lang=js&"
import style0 from "./VIPBag.vue?vue&type=style&index=0&id=1a9fb9b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9fb9b9",
  null
  
)

export default component.exports